<div class="wrapper-queue-cell-actions">
    <button class="btn btn-small cv-queue-btn-edit action-icon" title="Edit Queue" (click)="onEditQueue($event)">
        <i class="fa-regular fa-pencil"></i>
    </button>
    <button class="btn cv-queue-btn-remove action-icon" title="Remove Queue" (click)="onDeleteQueue($event)">
        <i class="fa-regular fa-trash"></i>
    </button>
</div>
